import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './campaign-tutorial-freeform.scss';

type Props = {
  title: string,
  children: React.ReactNode
};

const CampaignTutorialFreeform: React.FC<Props> = ({
  title,
  children
}): JSX.Element => (
  <div className="campaign-tutorial-freeform">
    <div className="campaign-tutorial-freeform__title">
      <div className="campaign-tutorial-freeform__icon">
        <SVGDynamicIcon
          name="info-inside-circle-custom-bg"
          width={24}
          height={24}
          customColor="blue"
        />
      </div>
      <div>
        {title}
      </div>
    </div>
    <div className="campaign-tutorial-freeform__body">
      {children}
    </div>
  </div>
);

export default CampaignTutorialFreeform;
